import DOMPurify from 'dompurify';

/**
 * Sanitize HTML Content
 * @param {String} str - The String to Sanitize.
 * @returns {String | null} - Return String or null.
 */
export function sanitize(str) {
    if (!str) return null;

    return DOMPurify.sanitize(str) || null;
}